import { createStore } from "vuex";
import { firestoreBindingMutations } from "@/store/firestoreBinding";
import SectionsService from "./modules/sections"; // Import the SectionsService module
import { RegionsService } from "@/store/modules/regions";
import { RiversService } from "@/store/modules/rivers";
import { GaugesService } from "@/store/modules/gauges";
import { PartnersService } from "@/store/modules/partners";
import levels from "@/store/modules/levels";

export const store = createStore({
  mutations: {
    ...firestoreBindingMutations,
  },
  modules: {
    SectionsService,
    RegionsService,
    RiversService,
    GaugesService,
    levels,
    PartnersService,
  },
});
